import { jsx as _jsx } from "react/jsx-runtime";
// Styles are inlined as these components will be rendered for PDF generation
export const ContainerView = ({ children }) => {
    return (_jsx("div", { style: {
            boxSizing: 'border-box',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        }, children: _jsx("div", { style: { maxWidth: '976px', margin: '0 auto' }, children: children }) }));
};
//# sourceMappingURL=conatiner_view.js.map